import { render, staticRenderFns } from "./tuandui.vue?vue&type=template&id=51b29986"
import script from "./tuandui.vue?vue&type=script&lang=js"
export * from "./tuandui.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports